export const environment = {
  production: true, 
  firebase: {
    apiKey: "AIzaSyAOHBIjKR9-jFLDh71Ftze26ldBIVBQSps",
    authDomain: "safe-lock-info-greece-2022.firebaseapp.com",
    projectId: "safe-lock-info-greece-2022",
    storageBucket: "safe-lock-info-greece-2022.appspot.com",
    messagingSenderId: "401937421315",
    appId: "1:401937421315:web:652b0e278deef4daa02a36",
    measurementId: "G-V61H1SYLEB"

  }
};
